export const LOCATION_COUNTRY_OTHER = "";
export const LOCATION_COUNTRY_SOUTH_AFRICA = "South Africa";
export const LOCATION_CITY_OTHER = "__other_city__";

export const COUNTRY_OPTIONS = [
  { value: LOCATION_COUNTRY_SOUTH_AFRICA, label: "South Africa" },
  { value: LOCATION_COUNTRY_OTHER, label: "Other / not configured yet" },
];

export const SOUTH_AFRICA_PROVINCES = [
  "Eastern Cape",
  "Free State",
  "Gauteng",
  "KwaZulu-Natal",
  "Limpopo",
  "Mpumalanga",
  "Northern Cape",
  "North West",
  "Western Cape",
];

export const SOUTH_AFRICA_CITIES = [
  "Johannesburg",
  "Pretoria",
  "Cape Town",
  "Durban",
  "Gqeberha",
  "Bloemfontein",
  "East London",
  "Pietermaritzburg",
  "Polokwane",
  "Mbombela",
  "Kimberley",
  "Rustenburg",
  "George",
];

export function normalizeLocationCountry(value = "") {
  const normalized = String(value || "").trim();
  if (/^(south africa|za|zaf)$/i.test(normalized)) return LOCATION_COUNTRY_SOUTH_AFRICA;
  return normalized;
}

export function isSouthAfricaCountry(value = "") {
  return normalizeLocationCountry(value) === LOCATION_COUNTRY_SOUTH_AFRICA;
}

export function normalizeProfileLocation({ country = "", province = "", city = "" } = {}) {
  const nextCountry = normalizeLocationCountry(country);
  if (!isSouthAfricaCountry(nextCountry)) {
    return {
      country: nextCountry,
      province: "",
      city: "",
    };
  }
  return {
    country: nextCountry,
    province: SOUTH_AFRICA_PROVINCES.includes(String(province || "").trim()) ? String(province || "").trim() : "",
    city: String(city || "").trim(),
  };
}
